module.exports = __webpack_public_path__ + "static/media/Oncology-Social and Lifestyle History-1@3x.cfce3e9e.png";